import React from 'react';
import { CRow, CCol, CSpinner, CAlert } from '@coreui/react';
import DateRangePicker from '../components/DateRangePicker';
import ChartCard from '../components/ChartCard';
import { getLineChartOptions, getPieChartOptions, CHART_COLORS } from '../utils/chartConfig';

const HistoryView = ({ dateRange, setDateRange, isLoading, error, data }) => {
  return (
    <>
      <div className="mb-4">
        <h3 className="text-primary mb-3">Historical Analytics</h3>
        <DateRangePicker 
          dateRange={dateRange} 
          onDateRangeChange={setDateRange} 
        />
      </div>
      
      {error && (
        <CAlert color="danger">
          {error}
        </CAlert>
      )}

      {isLoading ? (
        <div className="text-center my-5">
          <CSpinner color="primary" />
        </div>
      ) : (
        <CRow>
          <CCol md={4}>
            <ChartCard
              title="Measurement Usage"
              data={data.usage}
              chartType="LineChart"
              options={getLineChartOptions([CHART_COLORS[2]])}
            />
          </CCol>
          <CCol md={4}>
            <ChartCard
              title="New Device Registration"
              data={data.registerNum}
              chartType="LineChart"
              options={getLineChartOptions([CHART_COLORS[2]])}
            />
          </CCol>
          <CCol md={4}>
            <ChartCard
              title="Active Devices"
              data={data.deviceActiveRatio}
              chartType="LineChart"
              options={getLineChartOptions([CHART_COLORS[2]])}
            />
          </CCol>
          <CCol md={4}>
            <ChartCard
              title="Usage Distribution"
              data={data.usageDistribution}
              chartType="PieChart"
              options={getPieChartOptions()}
            />
          </CCol>
          <CCol md={4}>
            <ChartCard
              title="Platform Distribution"
              data={data.platformDistribution}
              chartType="PieChart"
              options={getPieChartOptions()}
            />
          </CCol>
          <CCol md={4}>
            <ChartCard
              title="App Distribution"
              data={data.appDistribution}
              chartType="PieChart"
              options={getPieChartOptions()}
            />
          </CCol>
        </CRow>
      )}
    </>
  );
};

export default HistoryView;